import { selectItemType } from '@src/types';
import { format } from 'date-fns';

export type FormValuesType = {
  rideRequestDate: string;
  startDate: string;
  endDate: string;
  state: selectItemType | null;
  showIncompleteRide: boolean;
};

export const defaultValues: FormValuesType = {
  rideRequestDate: format(Date.now(), 'MM/dd/yyyy'),
  startDate: '00:00',
  endDate: '23:59',
  state: null,
  showIncompleteRide: false,
};
